import { Card, CardContent } from "@/components/ui/card";
import { RollingNumber } from "@/components/ui/rolling-number";

export function StatTile({
  label,
  icon,
  value,
  hint,
  numericValue,
  formatFn,
}: {
  label: string;
  icon: React.ReactNode;
  value?: React.ReactNode;
  hint?: string;
  numericValue?: number;
  formatFn?: (v: number) => string;
}) {
  return (
    <Card>
      <CardContent>
        <div className="flex items-center justify-between">
          <div className="font-mono text-[10.5px] uppercase tracking-[0.12em] text-fg-mute">
            {label}
          </div>
          <span className="flex h-7 w-7 items-center justify-center rounded-md bg-aurora-soft text-violet">
            {icon}
          </span>
        </div>
        <div className="mt-2 text-3xl font-extrabold tracking-tight text-fg">
          {numericValue !== undefined && formatFn ? (
            <RollingNumber value={numericValue} format={formatFn} />
          ) : (
            value
          )}
        </div>
        {hint ? (
          <div className="mt-0.5 text-[11px] text-fg-mute">{hint}</div>
        ) : null}
      </CardContent>
    </Card>
  );
}
